import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Lock: React.FC<SvgProps> = (props) => {
  return (
    <Icon viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M11.5 7V4.5C11.5 3.70435 11.1839 2.94129 10.6213 2.37868C10.0587 1.81607 9.29565 1.5 8.5 1.5C7.70435 1.5 6.94129 1.81607 6.37868 2.37868C5.81607 2.94129 5.5 3.70435 5.5 4.5V7M5 14.5H12C12.3978 14.5 12.7794 14.342 13.0607 14.0607C13.342 13.7794 13.5 13.3978 13.5 13V8.5C13.5 8.10218 13.342 7.72064 13.0607 7.43934C12.7794 7.15804 12.3978 7 12 7H5C4.60218 7 4.22064 7.15804 3.93934 7.43934C3.65804 7.72064 3.5 8.10218 3.5 8.5V13C3.5 13.3978 3.65804 13.7794 3.93934 14.0607C4.22064 14.342 4.60218 14.5 5 14.5Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
